'use client';
import React from 'react';

interface MacroBarProps {
  label: string;
  consumed: number;
  target: number;
  unit?: string;
  color?: string;
}

export default function MacroBar({ label, consumed, target, unit = 'g', color = 'var(--primary)' }: MacroBarProps) {
  const pct = Math.min((consumed / target) * 100, 100);
  const over = consumed > target;
  const remaining = Math.max(target - consumed, 0);

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <span className="text-forge-label">{label}</span>
        <div className="flex items-center gap-2">
          <span className="font-tabular text-sm font-bold text-foreground">{consumed}{unit}</span>
          <span className="text-xs text-muted-foreground font-tabular">/ {target}{unit}</span>
          {over ? (
            <span className="text-2xs font-bold text-destructive">OVER</span>
          ) : (
            <span className="text-2xs font-medium text-muted-foreground">{remaining}{unit} left</span>
          )}
        </div>
      </div>
      <div className="macro-bar-track">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, backgroundColor: over ? 'var(--destructive)' : color }}
        />
      </div>
    </div>
  );
}